import { useNotification } from '@/shared/ui'
import { useHttp, useTranslate } from '@/shared/lib'
import { useMutation, useQueryClient } from '@tanstack/vue-query'

export const useSendForm = () => {
  const { addError, addSuccess } = useNotification()
  const http = useHttp()
  const { trs } = useTranslate()
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (data: any) => http.put(`/schedules/${data.id}`, data),
  })

  /* Отправка формы */
  const sendForm = async (data: any, valid: boolean) => {
    if (!valid) return

    try {
      await mutation.mutateAsync(data)

      addSuccess(trs('itf.schedules_edited'))

      /* Обновляем зависимые компоненты */
      const queryCache = queryClient.getQueryCache()

      queryCache.findAll({ queryKey: ['schedules'] }).forEach((item) => {
        item.fetch()
      })

      queryCache.find({ queryKey: ['load_schedules_tree', data.group_object_list_id] })?.fetch()

      queryCache.find({ queryKey: ['load_schedules_tree', data.old_group_object_list_id] })?.fetch()
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    sendForm,
  }
}
